<template>
    <div>
        <div class="modal-header">
            <h2>Gem filtrering</h2>
        </div>

        <div class="form">
            <label for="filter-name">Navn</label>
            <input type="text" name="filter-name" id="filter-name" v-model="filterName" />
        </div>

        <label>Aktive filtre</label>
        <div class="list-filter-group">
            <!-- GENEREL -->
            <template v-if="supplyTypes && supplyTypes.length > 1">
                <div class="list-filter-item" v-for="supplyType in supplyTypes" :key="supplyType.sysBusinessAreaTypeId" v-if="getFilters.supplyType.includes(supplyType.sysBusinessAreaTypeId)" :class="'list-filter-item--' + supplyType.systemName">
                    <span class="list-filter-item-label">Forretningsområde:</span><span class="list-filter-item-value"><icon class="tiny-svg" :name="supplyType.systemName" />{{ supplyType.description }}</span>
                </div>
            </template>

            <div class="list-filter-item" v-if="getFilters.address">
                <span class="list-filter-item-label">Adresse:</span><span class="list-filter-item-value">{{ getFilters.address }}</span>
            </div>

            <!-- ENQUIRIES -->
            <template v-if="this.getSelectedTab === 'requests'">
                <div class="list-filter-item" v-if="getFilters.enquiries.showClosed">
                    <span class="list-filter-item-label">Status:</span><span class="list-filter-item-value">Vis også afsluttede</span>
                </div>

                <div class="list-filter-item" v-for="responsible in getFilters.enquiries.responsible" :key="responsible">
                    <span class="list-filter-item-label">Ansvarlig:</span><span class="list-filter-item-value">{{ caseworkers.find(item => item.userId === responsible).name }}</span>
                </div>

                <div class="list-filter-item" v-for="problemType in getFilters.enquiries.problemType" :key="problemType">
                    <span class="list-filter-item-label">Problemtype:</span><span class="list-filter-item-value">{{ problemTypesList.find(item => item.id === problemType).area }}, {{ problemTypesList.find(item => item.id === problemType).name }}</span>
                </div>

                <div class="list-filter-item" v-for="contactType in getFilters.enquiries.contactType" :key="contactType">
                    <span class="list-filter-item-label">Kontakttype:</span><span class="list-filter-item-value">{{ contactTypesList.find(item => item.id === contactType).area }}, {{ contactTypesList.find(item => item.id === contactType).name }}</span>
                </div>

                <div class="list-filter-item" v-if="getFilters.enquiries.createdDate.from || getFilters.enquiries.createdDate.to">
                    <span class="list-filter-item-label">Problemdato<template v-if="getFilters.enquiries.createdDate.from && !getFilters.enquiries.createdDate.to"> efter</template><template v-if="!getFilters.enquiries.createdDate.from && getFilters.enquiries.createdDate.to"> før</template>:</span>
                    <span class="list-filter-item-value">
                        <template v-if="getFilters.enquiries.createdDate.from && getFilters.enquiries.createdDate.to">
                            {{ getFilters.enquiries.createdDate.from | formatDateShort }} - {{ getFilters.enquiries.createdDate.to | formatDateShort }}
                        </template>
                        <template v-if="getFilters.enquiries.createdDate.from && !getFilters.enquiries.createdDate.to">
                            {{ getFilters.enquiries.createdDate.from | formatDateShort }}
                        </template>
                        <template v-if="!getFilters.enquiries.createdDate.from && getFilters.enquiries.createdDate.to">
                            {{ getFilters.enquiries.createdDate.to | formatDateShort }}
                        </template>
                    </span>
                </div>
            </template>

            <!-- TASKS -->
            <template v-if="this.getSelectedTab === 'tasks'">
                <div class="list-filter-item" v-if="getFilters.tasks.showClosed">
                    <span class="list-filter-item-label">Status:</span><span class="list-filter-item-value">Vis også afsluttede</span>
                </div>

                <div class="list-filter-item" v-if="getFilters.tasks.showReadyForApproval">
                    <span class="list-filter-item-label">Status:</span><span class="list-filter-item-value">Vis kun færdigmeldte</span>
                </div>

                <div class="list-filter-item" v-for="responsible in getFilters.tasks.responsible" :key="responsible">
                    <span class="list-filter-item-label">Ansvarlig:</span><span class="list-filter-item-value">{{ caseworkers.find(item => item.userId === responsible).name }}</span>
                </div>

                <div class="list-filter-item" v-for="company in getFilters.tasks.company" :key="company">
                    <span class="list-filter-item-label">Virksomhed:</span><span class="list-filter-item-value">{{ firms.find(item => item.id === company).name }}</span>
                </div>

                <div class="list-filter-item" v-for="contact in getFilters.tasks.contact" v-if="users.find(item => item.userId === contact)" :key="contact">
                    <span class="list-filter-item-label">Medarbejder:</span><span class="list-filter-item-value">{{ users.find(item => item.userId === contact).name }}</span>
                </div>

                <div class="list-filter-item" v-if="getFilters.tasks.name">
                    <span class="list-filter-item-label">Opgavenavn:</span><span class="list-filter-item-value">{{ getFilters.tasks.name }}</span>
                </div>

                <div class="list-filter-item" v-if="getFilters.tasks.startDate.from || getFilters.tasks.startDate.to">
                    <span class="list-filter-item-label">Oprettet<template v-if="getFilters.tasks.startDate.from && !getFilters.tasks.startDate.to"> efter</template><template v-if="!getFilters.tasks.startDate.from && getFilters.tasks.startDate.to"> før</template>:</span>
                    <span class="list-filter-item-value">
                        <template v-if="getFilters.tasks.startDate.from && getFilters.tasks.startDate.to">
                            {{ getFilters.tasks.startDate.from | formatDateShort }} - {{ getFilters.tasks.startDate.to | formatDateShort }}
                        </template>
                        <template v-if="getFilters.tasks.startDate.from && !getFilters.tasks.startDate.to">
                            {{ getFilters.tasks.startDate.from | formatDateShort }}
                        </template>
                        <template v-if="!getFilters.tasks.startDate.from && getFilters.tasks.startDate.to">
                            {{ getFilters.tasks.startDate.to | formatDateShort }}
                        </template>
                    </span>
                </div>
            </template>

            <!-- REQUISITIONS -->
            <template v-if="this.getSelectedTab === 'requisitions'">
                <div class="list-filter-item" v-if="getFilters.requisitions.showApproved">
                    <span class="list-filter-item-label">Status:</span><span class="list-filter-item-value">Vis kun godkendte</span>
                </div>

                <div class="list-filter-item" v-if="getFilters.requisitions.dateOverdue">
                    <span class="list-filter-item-label">Tidsfrist:</span><span class="list-filter-item-value">Overskredet</span>
                </div>

                <div class="list-filter-item" v-if="getFilters.requisitions.serialNumber">
                    <span class="list-filter-item-label">Løbenummer:</span><span class="list-filter-item-value">{{ getFilters.requisitions.serialNumber }}</span>
                </div>

                <div class="list-filter-item" v-for="responsible in getFilters.requisitions.responsible" :key="responsible">
                    <span class="list-filter-item-label">Ansvarlig:</span><span class="list-filter-item-value">{{ caseworkers.find(item => item.userId === responsible).name }}</span>
                </div>

                <div class="list-filter-item" v-for="company in getFilters.requisitions.company" :key="company">
                    <span class="list-filter-item-label">Virksomhed:</span><span class="list-filter-item-value">{{ firms.find(item => item.id === company).name }}</span>
                </div>

                <div class="list-filter-item" v-for="contact in getFilters.requisitions.contact" v-if="users.find(item => item.userId === contact)" :key="contact">
                    <span class="list-filter-item-label">Medarbejder:</span><span class="list-filter-item-value">{{ users.find(item => item.userId === contact).name }}</span>
                </div>

                <div class="list-filter-item" v-for="activityType in getFilters.requisitions.activityType" :key="activityType">
                    <span class="list-filter-item-label">Aktivitetstype:</span><span class="list-filter-item-value">{{ activityTypesList.find(item => item.id === activityType).area }}, {{ activityTypesList.find(item => item.id === activityType).name }}</span>
                </div>

                <div class="list-filter-item" v-for="statusType in getFilters.requisitions.statusType" :key="statusType">
                    <span class="list-filter-item-label">Status:</span><span class="list-filter-item-value">{{ statusTypes.find(item => item.systemName === statusType).description }}</span>
                </div>

                <div class="list-filter-item" v-if="getFilters.requisitions.name">
                    <span class="list-filter-item-label">Opgavenavn:</span><span class="list-filter-item-value">{{ getFilters.requisitions.name }}</span>
                </div>

                <div class="list-filter-item" v-if="getFilters.requisitions.startDate.from || getFilters.requisitions.startDate.to">
                    <span class="list-filter-item-label">Oprettet<template v-if="getFilters.requisitions.startDate.from && !getFilters.requisitions.startDate.to"> efter</template><template v-if="!getFilters.requisitions.startDate.from && getFilters.requisitions.startDate.to"> før</template>:</span>
                    <span class="list-filter-item-value">
                        <template v-if="getFilters.requisitions.startDate.from && getFilters.requisitions.startDate.to">
                            {{ getFilters.requisitions.startDate.from | formatDateShort }} - {{ getFilters.requisitions.startDate.to | formatDateShort }}
                        </template>
                        <template v-if="getFilters.requisitions.startDate.from && !getFilters.requisitions.startDate.to">
                            {{ getFilters.requisitions.startDate.from | formatDateShort }}
                        </template>
                        <template v-if="!getFilters.requisitions.startDate.from && getFilters.requisitions.startDate.to">
                            {{ getFilters.requisitions.startDate.to | formatDateShort }}
                        </template>
                    </span>
                </div>
            </template>

            <!-- ROUTINES -->
            <template v-if="this.getSelectedTab === 'routines'">
                <div class="list-filter-item" v-if="getFilters.routines.showClosed">
                    <span class="list-filter-item-label">Status:</span><span class="list-filter-item-value">Vis også afsluttede</span>
                </div>

                <div class="list-filter-item" v-for="responsible in getFilters.routines.responsible" :key="responsible">
                    <span class="list-filter-item-label">Ansvarlig:</span><span class="list-filter-item-value">{{ caseworkers.find(item => item.userId === responsible).name }}</span>
                </div>

                <div class="list-filter-item" v-for="company in getFilters.routines.company" :key="company">
                    <span class="list-filter-item-label">Virksomhed:</span><span class="list-filter-item-value">{{ firms.find(item => item.id === company).name }}</span>
                </div>

                <div class="list-filter-item" v-if="getFilters.routines.name">
                    <span class="list-filter-item-label">Rutinenavn:</span><span class="list-filter-item-value">{{ getFilters.routines.name }}</span>
                </div>
            </template>
        </div>

        <div class="modal-footer">
            <div class="text-center modal-buttons">
                <button type="button" class="button-green" @click="filteringSave()">Gem</button>
                <button type="button" class="button-naked" @click="closeModal()">Luk</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'dashboard-modal-filters',
    props: {
    },
    data () {
        return {
            filterName: '',
            filterList: [],
            filterListLoading: false,
            sortKey: 'name',
            sortDirection: 'ASC'
        }
    },
    computed: {
        ...mapGetters({
            supplyTypes: 'getBusinessAreaTypes',
            caseworkers: 'caseWorkerList',
            problemTypes: 'getProblemTypes',
            contactTypes: 'getCClientTypeList',
            firms: 'getAllFirmsForActivity',
            users: 'getAllUsersInFirmForActivity',
            activityTypes: 'getCActivityTypeList',
            statusTypes: 'getSysRequisitionAndReportStatusList',

            getSelectedTab: 'getSelectedTab',
            getFilters: 'getFilters'
        }),

        contactTypesList () {
            const contactTypeList = []

            this.supplyTypes.forEach((supplyType) => {
                Object.values(this.contactTypes).find(value => value && value.businessAreaTypeId === supplyType.sysBusinessAreaTypeId).codeList.forEach((contactType) => {
                    contactTypeList.push({
                        id: contactType.typeId,
                        name: contactType.description,
                        area: supplyType.description
                    })
                })
            })

            return contactTypeList
        },
        problemTypesList () {
            const problemTypeList = []

            this.supplyTypes.forEach((supplyType) => {
                Object.values(this.problemTypes).find(value => value && value.businessAreaTypeId === supplyType.sysBusinessAreaTypeId).codeList.forEach((problemType) => {
                    problemTypeList.push({
                        id: problemType.typeId,
                        name: problemType.description,
                        area: supplyType.description
                    })
                })
            })

            return problemTypeList
        },
        activityTypesList () {
            const activityTypeList = []

            this.supplyTypes.forEach((supplyType) => {
                Object.values(this.activityTypes).find(value => value && value.businessAreaTypeId === supplyType.sysBusinessAreaTypeId).codeList.forEach((activityType) => {
                    activityTypeList.push({
                        id: activityType.typeId,
                        name: activityType.description,
                        area: supplyType.description
                    })
                })
            })

            return activityTypeList
        }
    },
    methods: {
        ...mapActions({
            saveQueryRequestFiltering: 'saveQueryRequestFiltering',
            saveQueryTaskFiltering: 'saveQueryTaskFiltering',
            saveQueryRequisitionFiltering: 'saveQueryRequisitionFiltering',
            saveQueryRoutineFiltering: 'saveQueryRoutineFiltering'
        }),

        filteringSave () {
            if (this.getSelectedTab === 'requests') {
                const enquiryQuery = {
                    saveFilter: true,
                    filterName: this.filterName
                }
                this.saveQueryRequestFiltering({...this.getFilters.enquiries, ...enquiryQuery})
                    .then(() => {
                        this.closeModal()
                    })
                    .catch((error) => {
                        console.error('ERROR: ', error)
                    })
            } else if (this.getSelectedTab === 'tasks') {
                const taskQuery = {
                    saveFilter: true,
                    filterName: this.filterName
                }
                this.saveQueryTaskFiltering({...this.getFilters.tasks, ...taskQuery})
                    .then(() => {
                        this.closeModal()
                    })
                    .catch((error) => {
                        console.error('ERROR: ', error)
                    })
            } else if (this.getSelectedTab === 'requisitions') {
                const requisitionQuery = {
                    saveFilter: true,
                    filterName: this.filterName
                }
                this.saveQueryRequisitionFiltering({...this.getFilters.requisitions, ...requisitionQuery})
                    .then(() => {
                        this.closeModal()
                    })
                    .catch((error) => {
                        console.error('ERROR: ', error)
                    })
            } else if (this.getSelectedTab === 'routines') {
                const routineQuery = {
                    saveFilter: true,
                    filterName: this.filterName
                }
                this.saveQueryRoutineFiltering({...this.getFilters.routines, ...routineQuery})
                    .then(() => {
                        this.closeModal()
                    })
                    .catch((error) => {
                        console.error('ERROR: ', error)
                    })
            }
        },
        closeModal () {
            this.$emit('close')
        }
    },
    mounted () {
        if (this.getSelectedTab === 'requests') {
            this.filterName = 'Henvendelser - '
        } else if (this.getSelectedTab === 'tasks') {
            this.filterName = 'Opgaver - '
        } else if (this.getSelectedTab === 'requisitions') {
            this.filterName = 'Entreprenøropgaver - '
        } else if (this.getSelectedTab === 'routines') {
            this.filterName = 'Rutiner - '
        }
        this.filterName += this.$filters.formatDateShort(new Date())
    }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/dashboard/dashboard-modal-filter-save.vue